import React, { useState } from "react";
import "../styles/Notice.css";
import { FaFilePdf, FaEye } from "react-icons/fa";

// ✅ Import PDFs
import OfficeNotice from "../Assets/Pdfs/office notice.pdf";
import AdmissionInfo2025 from "../Assets/Pdfs/Admission Notice for 2026.pdf";
import FinalFormFillupNine from "../Assets/Pdfs/Final form fillup for class Nine.pdf";



// ✅ Notices List
const notices = [
  {
    id: 1,
    title: "অফিস বিজ্ঞপ্তি",
    date: "2025-10-15",
    pdf: OfficeNotice,
    filename: "office notice.pdf"
  },
  {
    id: 2,
    title: "২০২৬ শিক্ষাবর্ষে ষষ্ঠ থেকে দশম শ্রেণীতে ভর্তি সংক্রান্ত বিজ্ঞপ্তি",
    date: "2025-10-13",
    pdf: AdmissionInfo2025,
    filename: "Admission Notice 2025.pdf"
  },

  {
    id: 3,
    title: "বাংলাদেশ কারিগরি শিক্ষা বোর্ডে নবম শ্রেণীর চূড়ান্ত ফরম ফিলাপ প্রসঙ্গে",
    date: "2025-10-09",
    pdf: FinalFormFillupNine,
    filename: "Final form fillup for class Nine.pdf"
  },
  {
    id: 4,
    title: "২০২৫ শিক্ষাবর্ষে ষষ্ঠ থেকে দশম শ্রেণীতে ভর্তি সংক্রান্ত বিজ্ঞপ্তি",
    date: "2025-10-09",
    pdf: AdmissionInfo2025,
    filename: "Admission Notice 2025.pdf"
  },
   
];

export default function NoticePage() {
  const [searchTerm, setSearchTerm] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  // ✅ Filtered Notices
  const filteredNotices = notices.filter((notice) =>
    notice.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // ✅ Pagination
  const totalPages = Math.ceil(filteredNotices.length / entriesPerPage);
  const startIndex = (currentPage - 1) * entriesPerPage;
  const currentNotices = filteredNotices.slice(
    startIndex,
    startIndex + entriesPerPage
  );

  const handleEntriesChange = (e) => {
    setEntriesPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const handlePageChange = (pageNum) => {
    if (pageNum >= 1 && pageNum <= totalPages) setCurrentPage(pageNum);
  };

  return (
    <div className="notice-page">
      <h2 className="notice-title">Notice</h2>

      {/* ✅ Controls */}
      <div className="notice-controls">
        <div className="entries">
          Show
          <select value={entriesPerPage} onChange={handleEntriesChange}>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
          </select>
          entries
        </div>

        <div className="search-box">
          <label>Search: </label>
          <input
            type="text"
            placeholder="নোটিশ খুঁজুন..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {/* ✅ Notice Table */}
      <table className="notice-table">
        <thead>
          <tr>
            <th>ক্রমিক</th>
            <th>শিরোনাম</th>
            <th>প্রকাশের তারিখ</th>
            <th>দেখুন</th>
            <th>ডাউনলোড</th>
          </tr>
        </thead>
        <tbody>
          {currentNotices.map((notice, index) => (
            <tr key={notice.id}>
              <td>{startIndex + index + 1}</td>
              <td>{notice.title}</td>
              <td>{notice.date}</td>
              <td className="pdf-icon">
                {/* ✅ View PDF */}
                <a href={notice.pdf} target="_blank" rel="noreferrer">
                  <FaEye className="view-btn" title="View PDF" />
                </a>
                
              </td>

              <td className="pdf-icon">
                {/* ✅ Download PDF */}
                <a href={notice.pdf} download={notice.filename}>
                  <FaFilePdf className="pdf-btn" title="Download PDF" />
                </a>
                
              </td>
            </tr>
          ))}

          {currentNotices.length === 0 && (
            <tr>
              <td colSpan="4" className="no-data">
                কোনো নোটিশ পাওয়া যায়নি
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* ✅ Pagination */}
      <div className="pagination">
        <p>
          Showing {startIndex + 1} to{" "}
          {Math.min(startIndex + entriesPerPage, filteredNotices.length)} of{" "}
          {filteredNotices.length} entries
        </p>

        <div className="page-buttons">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>

          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              onClick={() => handlePageChange(i + 1)}
              className={currentPage === i + 1 ? "active" : ""}
            >
              {i + 1}
            </button>
          ))}

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}
